import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  sessionExpired$ = new Subject<void>();
  constructor() { }

  notifySessionExpired(): void {
    this.sessionExpired$.next();
  }
}

